
import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getGrupoPartida, modifyGrupoPartida, removeGrupoPartida, addGrupoPartida, updateGrupoPartidaDB } from '../../actions/grupo_partida_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresGrupoPartida extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getGrupoPartida();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvGrupoPartida = (grupoPartida) => {
        if (this.props.grupoPartida.find(c => (c.descr === grupoPartida.descr) && (c.id !== grupoPartida.id))) {
            this.messageDialog(`Ya existe un grupo de partida ${grupoPartida.descr}`);
            return false;
        } else if (!grupoPartida.descr.trim()) {
            this.messageDialog('Por favor, introduzca un Nombre');
            return false;
        }

        else return true;
    };

    addNewGrupoPartida = grupoPartida => {
        this.props.setSaveState(true);
        this.props.addGrupoPartida(grupoPartida);
    };

    newGrupoPartida = () => {
        this.props.openDialog('EditCvGrupoPartida', {
            cvGrupoPartida: {},
            okHandler: this.addNewGrupoPartida,
            checkGrupoPartida: this.checkCvGrupoPartida,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.props.grupoPartida[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyGrupoPartida(updatedRow);
        // };

        let updatedRow = update(this.props.grupoPartida[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyGrupoPartida(updatedRow);

    };

    handleDeleteRow = grupoPartida => {
        this.props.setSaveState(true);
        this.props.removeGrupoPartida(grupoPartida);
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                    <NeuriteGrid
                        id="m_a_g_p"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 115 }
                        ]}
                        rows={this.props.grupoPartida}
                        height={500}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newGrupoPartida}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.grupoPartida.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateGrupoPartidaDB(this.props.grupoPartida)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresGrupoPartida.propTypes = {
    //state
    grupoPartida: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getGrupoPartida: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyGrupoPartida: PropTypes.func.isRequired,
    removeGrupoPartida: PropTypes.func.isRequired,
    addGrupoPartida: PropTypes.func.isRequired,
    updateGrupoPartidaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        grupoPartida: state.grupoPartida.grupospartida,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getGrupoPartida,
        openDialog,
        hideDialog,
        modifyGrupoPartida,
        removeGrupoPartida,
        addGrupoPartida,
        updateGrupoPartidaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresGrupoPartida));